/** Coalesce invalidations, keep updates arriving during a fetch, retry failures. */
export function createRealtimeRefresh(refresh: () => Promise<void>, onError: (error: unknown) => void, delay = 300) {
  let timer: ReturnType<typeof setTimeout> | undefined
  let running = false
  let dirty = false
  let stopped = false
  let retryDelay = 1000

  const schedule = (ms: number) => {
    if (stopped || running || timer) return
    timer = setTimeout(() => { timer = undefined; void run() }, ms)
  }
  const run = async () => {
    if (stopped || running || !dirty) return
    running = true
    dirty = false
    let failed = false
    console.log('🔄 [RealtimeRefresh] Выполняется фоновое обновление данных (run)...')
    try {
      await refresh()
      retryDelay = 1000
      console.log('✅ [RealtimeRefresh] Фоновое обновление успешно выполнено')
    } catch (error) {
      failed = true
      dirty = true
      console.error(`❌ [RealtimeRefresh] Ошибка при фоновом обновлении данных! Повтор через ${retryDelay} мс:`, error)
      onError(error)
    } finally {
      running = false
      if (dirty) schedule(failed ? retryDelay : delay)
      if (failed) retryDelay = Math.min(retryDelay * 2, 30_000)
    }
  }
  return {
    invalidate(reason?: string) {
      dirty = true
      console.log(`⚡ [RealtimeRefresh] Инвалидация данных запрошена${reason ? ` (${reason})` : ''}, запуск через ${delay} мс...`)
      schedule(delay)
    },
    stop() {
      stopped = true
      dirty = false
      clearTimeout(timer)
      timer = undefined
      console.log('⏹️ [RealtimeRefresh] Планировщик остановлен (stop)')
    },
  }
}
